import { z } from "zod";

export const chatConversationSchema = z.object({
  messages: z.array(
    z.object({ role: z.string().optional(), content: z.string().optional() })
  ),
  temperature: z.number().optional().nullable(),
  maxTokens: z.number().optional().nullable(),
  systemPrompt: z.string().optional(),
});

export type ChatConversationSchema = z.infer<typeof chatConversationSchema>;